"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.78.87a.61.61,0,0,0-.61.61,14.24,14.24,0,0,1-.6,4.38c-.19.36-.38.72-.57,1.07C.77,9.17-.49,11.48.2,15.27a12.39,12.39,0,0,0,3,6v1.89h3v-.86h.65v.86h3v-.86h.65v.86h3v-.86h.65v.86h3v-.86h.65v.86h3V21.24a12.4,12.4,0,0,0,3-6c.69-3.79-.58-6.1-1.8-8.34-.19-.35-.39-.71-.57-1.07a14.26,14.26,0,0,1-.6-4.38.61.61,0,0,0-.61-.61Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,14a.57.57,0,0,1-.57-.57V4.8a.57.57,0,0,1,1.14,0v8.61A.57.57,0,0,1,12,14Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,18a1,1,0,1,1,1-1A1,1,0,0,1,12,18Z",
    fill: "#fff"
  }));
};

exports["default"] = _default;